"use client"
//logica scanner web npms
//npm install @zxing/library @zxing/browser
import { useState, useEffect, useContext, useMemo, useRef } from "react"
import { useNavigate, useParams, useLocation } from "react-router-dom"
import Cookies from "js-cookie"
import { DataGrid } from "@mui/x-data-grid"
import Paper from "@mui/material/Paper"
import EditIcon from "@mui/icons-material/Edit"
import CloseIcon from "@mui/icons-material/Close"
import WarningIcon from "@mui/icons-material/Warning"
import InventoryIcon from "@mui/icons-material/Inventory"
import DeleteIcon from "@mui/icons-material/Delete" // Importando icono de eliminar
import { ErpContext } from "../../context/ErpContext.js"
import dayjs from "dayjs"
// CreateItemComponentModal ya no se usa - ahora CreateServicioComponent maneja crear y editar
import CreateServicioComponent from "./CreateServicioComponent.js"
import CustomPagination from "../transaccionComponent/CustomPagination.js"
import BuscadorItemsUbicaciones from "./BuscadorItemsUbicaciones.js"
import SpinnerLading from "../misc/SpinnerComponent.js"
import GestionGenerarCompraComponent from "../transaccionComponent/GestionGenerarCompraComponent.js"
import AddIcon from "@mui/icons-material/Add"
import LocationOnIcon from "@mui/icons-material/LocationOn"
import TuneIcon from "@mui/icons-material/Tune"
import FileDownloadIcon from "@mui/icons-material/FileDownload"
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered"
import NewReleasesIcon from "@mui/icons-material/NewReleases"
import FilterAltIcon from "@mui/icons-material/FilterAlt"
import SearchIcon from "@mui/icons-material/Search"
import ClearIcon from "@mui/icons-material/Clear"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"
import BusinessIcon from "@mui/icons-material/Business"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"

import {
  IconButton,
  Modal,
  Box,
  Button,
  Typography,
  Chip,
  Tooltip,
  alpha,
  useTheme,
  Checkbox,
  FormControlLabel,
  Autocomplete,
  Drawer,
  Divider,
  TextField,
  InputAdornment,
  Badge,
  CircularProgress,
} from "@mui/material"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { generarPdfVerServicios } from "../../context/pdf_esqueletos/verServiciosPdf"
import { reservePdfTarget } from "../../context/pdf_esqueletos/helpers/pdfDelivery.js"

export default function InventarioComponent() {
  const theme = useTheme()
  const navigate = useNavigate()
  const { tenant } = useParams()
  const location = useLocation()
  const tenantPath = tenant || Cookies.get("tenantURL") || "default"
  const FILTER_PANEL_WIDTH = 50
  const DATA_GRID_MIN_WIDTH = 1100

  const {
    user,
    getItemAndItemUbicacionServicios,
    getUbicacion,
    getDeletedItemUbicacion,
    itemAtributoServicioNoEliminados,
    getItemAtributoServicioNoEliminados,
    ubicaciones,
    isNavbarCollapsed,
    getParametrosGlobales,
    exportarPLUsBalanza,
    bulkDeleteItems,
    getPaquetesByServicio,
    getFechaHoraActualClient,
    entidadesClientesTresLetras,
    getEntidadesClientesTresLetras,
  } = useContext(ErpContext)

  const [itemEditable, setItemEditable] = useState([])
  const [openModal, setOpenModal] = useState(false)
  const [alignment, setAlignment] = useState("inventario")
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [totalCount, setTotalCount] = useState(0)
  const [itemAndItemUbicacion, setItemAndItemUbicacion] = useState([])
  const [filters, setFilters] = useState({})
  const [selectedItems, setSelectedItems] = useState([])
  const [selectAll, setSelectAll] = useState(false)
  const [openCompraModal, setOpenCompraModal] = useState(false)
  const [compraData, setCompraData] = useState(null)
  const [parametrosGlobales, setParametrosGlobales] = useState({})
  const [ubicacionSeleccionada, setUbicacionSeleccionada] = useState(null)
  const [soloItemsConPLU, setSoloItemsConPLU] = useState(false)

  const [filtroUltimosCreados, setFiltroUltimosCreados] = useState(false)

  const [mostrarFiltroAtributos, setMostrarFiltroAtributos] = useState(false)
  const [mostrarFiltroPLU, setMostrarFiltroPLU] = useState(false)
  const [filtrosAtributos, setFiltrosAtributos] = useState({})
  const [filtroEsVendedor, setFiltroEsVendedor] = useState(false)
  const [filtroNoEsVendedor, setFiltroNoEsVendedor] = useState(false)

  const [modoEliminacion, setModoEliminacion] = useState(false)
  const [itemsSeleccionadosParaEliminar, setItemsSeleccionadosParaEliminar] = useState([])
  const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false)
  const [openCrearServicioModal, setOpenCrearServicioModal] = useState(false)
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [sortModel, setSortModel] = useState([{ field: "fechaListaMontosTimestamp", sort: "desc" }])
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false)
  const [selectedProveedorFiltro, setSelectedProveedorFiltro] = useState(null)
  const [searchTextProveedorFiltro, setSearchTextProveedorFiltro] = useState("")
  
  // Estados para eliminación individual desde acciones
  const [openDeleteConfirmModal, setOpenDeleteConfirmModal] = useState(false)
  const [itemToDelete, setItemToDelete] = useState(null)
  const [openBlockedDeleteModal, setOpenBlockedDeleteModal] = useState(false)
  const [paquetesAsociados, setPaquetesAsociados] = useState([])
  const [loadingPaquetesAsociados, setLoadingPaquetesAsociados] = useState(false)

  // Guards para evitar loops si las funciones del Context cambian de referencia
  const parametrosGlobalesLoadedRef = useRef(false)
  const atributosLoadedRef = useRef(false)

  const showPluExport = parametrosGlobales.pluBalanza === "1"

  const hayFiltroUbicacion = !!filters.ubicacionId
  const tipoEliminacion = hayFiltroUbicacion ? "itemUbicacion" : "itemCompleto"

  const attributeLabels = itemAtributoServicioNoEliminados
    .filter((attr) => !attr.eliminado)
    .reduce((acc, attr, index) => {
      acc[`itemDatoAtributo${attr.id}`] = attr.descripcion
      return acc
    }, {})

  // SOLUCIÓN BUCLE INFINITO: Usar JSON.stringify para comparar filtrosAtributos por valor
  const filtrosAtributosKey = useMemo(() => JSON.stringify(filtrosAtributos), [filtrosAtributos])

  const formatCurrency = (value) => {
    if (typeof value !== "number") return "Sin información"
    return value.toLocaleString("es-AR", { style: "currency", currency: "ARS" })
  }
  useEffect(() => {
    setLoading(false)
  }, [itemAndItemUbicacion])

  useEffect(() => {
    if (searchTextProveedorFiltro.length >= 3) {
      getEntidadesClientesTresLetras(searchTextProveedorFiltro, [2])
    }
  }, [searchTextProveedorFiltro, getEntidadesClientesTresLetras])

  useEffect(() => {
    if (itemAndItemUbicacion.length === 0) {
      setSelectedItems([])
      setSelectAll(false)
      setItemsSeleccionadosParaEliminar([]) // Limpiar selección de eliminación si no hay items
      setModoEliminacion(false) // Desactivar modo eliminación si no hay items
    }
  }, [itemAndItemUbicacion])

  // Aplicar filtro de proveedor inicial si se navegó desde TablaEntidadProveedor
  useEffect(() => {
    const proveedorId = location.state?.proveedorId
    const proveedorDescripcion = location.state?.proveedorDescripcion
    if (proveedorId) {
      setFilters((prev) => ({ ...prev, proveedorId }))
      setSelectedProveedorFiltro({ id: proveedorId, descripcion: proveedorDescripcion || "" })
      setPage(1)
    }
  }, [])

  // Cargar atributos solo una vez al montar el componente
  useEffect(() => {
    if (atributosLoadedRef.current) return
    atributosLoadedRef.current = true

    const cargarAtributos = async () => {
      try {
        await getItemAtributoServicioNoEliminados()
      } catch (error) {
        console.error("Error al cargar atributos:", error)
      }
    }

    cargarAtributos()
  }, [getItemAtributoServicioNoEliminados])

  // Cargar parametros globales solo una vez al montar
  useEffect(() => {
    if (parametrosGlobalesLoadedRef.current) return
    parametrosGlobalesLoadedRef.current = true

    const cargarParametrosGlobales = async () => {
      try {
        const parametros = await getParametrosGlobales(["pluBalanza", "fabricanteBalanza", "formatoFechas"])
        setParametrosGlobales(parametros || {})
      } catch (error) {
        console.error("Error al cargar parámetros globales:", error)
      }
    }

    cargarParametrosGlobales()
  }, [getParametrosGlobales])

  const formatearFechaHora = (timestamp) => {
    if (!timestamp || isNaN(timestamp)) return null
    const fmt = parametrosGlobales?.formatoFechas
    const localeNavegador = typeof navigator !== "undefined" ? navigator.language : "es-AR"
    if (fmt) {
      return dayjs(timestamp).format(`${fmt} hh:mm a`)
    }
    return new Intl.DateTimeFormat(localeNavegador || "es-AR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).format(new Date(timestamp))
  }

  const SORT_FIELD_LABELS = {
    fechaListaMontosTimestamp: "Fecha",
    ubicacion: "Destino",
    codigo: "Servicio",
    proveedor: "Proveedor",
    precioProveedor: "Costo",
    categoria: "Categoria",
    vendedor: "Vendedor",
  }

  const handleExportarPLUsBalanza = async () => {
    if (!ubicacionSeleccionada) {
      alert("Debe seleccionar una ubicación antes de exportar")
      return
    }

    try {
      await exportarPLUsBalanza(ubicacionSeleccionada)
    } catch (error) {
      console.error("Error al exportar PLUs de balanza:", error)
      alert("Error al exportar PLUs de balanza: " + error.message)
    }
  }

  const isExportButtonEnabled = () => {
    return parametrosGlobales.pluBalanza === "1" && parametrosGlobales.fabricanteBalanza && ubicacionSeleccionada
  }

  const handleToggleFiltroUltimosCreados = () => {
    const newValue = !filtroUltimosCreados
    setFiltroUltimosCreados(newValue)
    setFilters((prev) => ({ ...prev, mostrarUltimosCreados: newValue }))
    setPage(1)
  }

  const handleToggleFiltroPLU = () => {
    const newValue = !soloItemsConPLU
    setSoloItemsConPLU(newValue)
    setFilters((prev) => ({ ...prev, soloItemsConPLU: newValue }))
    setPage(1)
  }

  const handleSortModelChange = (newSortModel) => {
    const nextField = newSortModel?.[0]?.field || "fechaListaMontosTimestamp"
    if (nextField === "action") {
      return
    }
    const nextSort = newSortModel?.[0]?.sort === "asc" ? "asc" : "desc"
    setSortModel([{ field: nextField, sort: nextSort }])
    setPage(1)
  }

  const mapearAtributosACampos = () => {
    return itemAtributoServicioNoEliminados
      .filter((attr) => !attr.eliminado && attr.id === 6)
      .map((attr) => ({
        id: attr.id,
        descripcion: "Categoria",
        campo: `itemDatoAtributo${attr.id}`,
        index: attr.id,
      }))
  }

  const handleAtributoFilterChange = (campo, valor) => {
    setFiltrosAtributos((prev) => ({
      ...prev,
      [campo]: valor,
    }))
  }

  const handleAplicarFiltrosAtributos = () => {
    fetchData(
      filters.ubicacionId,
      filters.itemId,
      filters.precio,
      filters.soloStockBajo,
      filters.mostrarUltimosCreados,
      filters.mostrarRecetas,
      filters.proveedorId,
      filters.searchText,
      !!filters.soloItemsConPLU,
      filtrosAtributos,
      filtroEsVendedor,
      filtroNoEsVendedor,
    )
  }

  const handleAtributoKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault()
      handleAplicarFiltrosAtributos()
    }
  }

  const cantidadFiltrosAtributosActivos = Object.values(filtrosAtributos).filter(
    (valor) => valor && valor.trim() !== "",
  ).length
  const badgeFiltrosAtributos =
    cantidadFiltrosAtributosActivos + (filtroEsVendedor ? 1 : 0) + (filtroNoEsVendedor ? 1 : 0)

  const contarFiltrosActivos = () => {
    let contador = 0
    if (filtroUltimosCreados) contador++
    if (soloItemsConPLU) contador++
    if (filtroEsVendedor) contador++
    if (filtroNoEsVendedor) contador++
    if (cantidadFiltrosAtributosActivos > 0) contador += cantidadFiltrosAtributosActivos
    return contador
  }

  const toggleFilterDrawer = () => {
    setFilterDrawerOpen(!filterDrawerOpen)
  }

  const deleteCheckboxColumn = modoEliminacion
    ? [
        {
          field: "selectDelete",
          headerName: "Eliminar",
          flex: 0.5,
          minWidth: 90,
          headerAlign: "center",
          sortable: false,
          renderHeader: () => (
            <Checkbox
              checked={
                itemsSeleccionadosParaEliminar.length === itemAndItemUbicacion.length && itemAndItemUbicacion.length > 0
              }
              indeterminate={
                itemsSeleccionadosParaEliminar.length > 0 &&
                itemsSeleccionadosParaEliminar.length < itemAndItemUbicacion.length
              }
              onChange={(e) => handleSelectAllForDelete(e.target.checked)}
              size="small"
              color="error"
            />
          ),
          renderCell: (params) => (
            <Checkbox
              checked={itemsSeleccionadosParaEliminar.includes(params.row.idItem)}
              onChange={(e) => handleSelectItemForDelete(params.row.idItem, e.target.checked)}
              size="small"
              color="error"
            />
          ),
        },
      ]
    : []

  const staticColumnsBefore = [
    {
      field: "fechaListaMontosTimestamp",
      headerName: "Fecha",
      flex: 1,
      minWidth: 120,
      headerAlign: "center",
      align: "center",
      type: "dateTime",
      sortable: true,
      sortingOrder: ["desc", "asc"],
      valueGetter: (params) => params?.row?.fechaListaMontosTimestamp ?? null,
      sortComparator: (v1, v2) => {
        const n1 = Number.isFinite(v1) ? v1 : v1 ? Number(v1) : null
        const n2 = Number.isFinite(v2) ? v2 : v2 ? Number(v2) : null
        if (n1 === null && n2 === null) return 0
        if (n1 === null) return 1
        if (n2 === null) return -1
        return n1 - n2
      },
      renderCell: (params) => (
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
          <Typography variant="body2">
            {params.row.fechaListaMontosDisplay || "-"}
          </Typography>
        </Box>
      ),
    },
  ]

  const staticColumnsAfter = [
    {
      field: "ubicacion",
      headerName: "Destino",
      flex: 1,
      minWidth: 120,
      headerAlign: "center",
      align: "left",
      sortable: true,
      sortingOrder: ["asc", "desc"],
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: 1, width: "100%" }}>
          <LocationOnIcon fontSize="small" sx={{ color: alpha("#5b5b5f", 0.7) }} />
          <Typography variant="body2">{params.value}</Typography>
        </Box>
      ),
    },
    {
      field: "codigo",
      headerName: "Servicio",
      flex: 1,
      minWidth: 120,
      headerAlign: "center",
      align: "left",
      sortable: true,
      sortingOrder: ["asc", "desc"],
      renderCell: (params) => (
        <Box sx={{ display: "flex", justifyContent: "flex-start", width: "100%" }}>
          <Chip
            label={params.value}
            size="small"
            variant="outlined"
            sx={{
              fontWeight: 500,
              borderColor: "rgb(244, 147, 14)",
              color: "rgb(244, 147, 14)",
            }}
          />
        </Box>
      ),
    },
    {
      field: "proveedor",
      headerName: "Proveedor",
      flex: 1.5,
      minWidth: 150,
      headerAlign: "center",
      align: "left",
      sortable: true,
      sortingOrder: ["asc", "desc"],
      renderCell: (params) => (
        <Box sx={{ display: "flex", justifyContent: "flex-start", width: "100%" }}>
          <Tooltip title={params.value || "Sin proveedor"} arrow>
            <Typography 
              variant="body2"
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                textAlign: "left",
                fontWeight: params.row.idEntidad === 2 ? 400 : 500,
                color: params.row.idEntidad === 2 ? "text.secondary" : "text.primary",
              }}
            >
              {params.value || "-"}
            </Typography>
          </Tooltip>
        </Box>
      ),
    },
    {
      field: "precioProveedor",
      headerName: "Costo",
      flex: 1,
      minWidth: 100,
      headerAlign: "center",
      align: "right",
      sortable: true,
      sortingOrder: ["desc", "asc"],
      renderCell: (params) => (
        <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
          <Typography sx={{ color: "#4CAF50", fontWeight: "bold" }}>
            ${params.value?.toLocaleString("es-AR") || "0.00"}
          </Typography>
        </Box>
      ),
    },
    {
      field: "categoria",
      headerName: "Categoria",
      flex: 1,
      minWidth: 140,
      headerAlign: "center",
      align: "left",
      sortable: true,
      sortingOrder: ["asc", "desc"],
      renderCell: (params) => (
        <Box sx={{ display: "flex", justifyContent: "flex-start", width: "100%" }}>
          <Typography variant="body2">
            {params.row.activeAttributes?.itemDatoAtributo6 ||
              params.row.activeAttributes?.itemDatoAtributo1 ||
              "-"}
          </Typography>
        </Box>
      ),
    },
    {
      field: "vendedor",
      headerName: "Vendedor",
      flex: 1,
      minWidth: 140,
      headerAlign: "center",
      align: "center",
      sortable: true,
      sortingOrder: ["asc", "desc"],
      renderCell: (params) => (
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
          {params.row.vendedor ? (
            <CheckCircleIcon sx={{ fontSize: 18, color: "#4CAF50" }} />
          ) : null}
        </Box>
      ),
    },
    {
      field: "action",
      headerName: "Acciones",
      width: 120,
      headerAlign: "center",
      align: "center",
      sortable: false,
      hideSortIcons: true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 0.5, justifyContent: "center" }}>
          <IconButton
            onClick={() => {
              setItemEditable(params.row)
              setOpenModal(true)
            }}
            sx={{
              color: theme.palette.primary.main,
              "&:hover": {
                backgroundColor: alpha(theme.palette.primary.main, 0.2),
              },
              transition: "background-color 0.2s",
            }}
          >
            <EditIcon fontSize="small" />
          </IconButton>
          
          <IconButton
            onClick={async () => {
              const row = params.row
              setItemToDelete(row)
              setLoadingPaquetesAsociados(true)
              try {
                const paquetes = await getPaquetesByServicio(row.idItem, row.idUbicacion, row.idEntidad)
                if (paquetes && paquetes.length > 0) {
                  setPaquetesAsociados(paquetes)
                  setOpenBlockedDeleteModal(true)
                } else {
                  setOpenDeleteConfirmModal(true)
                }
              } finally {
                setLoadingPaquetesAsociados(false)
              }
            }}
            sx={{
              color: theme.palette.error.main,
              "&:hover": {
                backgroundColor: alpha(theme.palette.error.main, 0.2),
              },
              transition: "background-color 0.2s",
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      ),
    },
  ]

  const dynamicColumns = itemAtributoServicioNoEliminados
    .filter((attr) => !attr.eliminado)
    .map((attr) => ({
      field: `itemDatoAtributo${attr.id}`,
      headerName: attr.descripcion,
      width: 150,
      headerAlign: "center",
      align: "right",
      renderCell: (params) => (
        <Box sx={{ display: "flex", justifyContent: "flex-start", width: "100%" }}>
          <Typography variant="body2">
            {params.row.activeAttributes ? params.row.activeAttributes[`itemDatoAtributo${attr.id}`] || "-" : "-"}
          </Typography>
        </Box>
      ),
    }))

  const precioProveedorColumn = filters.proveedorId
    ? [
        {
          field: "precioProveedor",
          headerName: "Precio Proveedor",
          width: 130,
          headerAlign: "center",
          align: "right",
          renderCell: (params) => (
            <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
              <Chip
                label={params.value ? `$${params.value.toLocaleString("es-AR")}` : "N/A"}
                size="small"
                variant="outlined"
                sx={{
                  fontWeight: 500,
                  borderColor: params.value ? "rgb(76, 175, 80)" : "rgb(158, 158, 158)",
                  color: params.value ? "rgb(76, 175, 80)" : "rgb(158, 158, 158)",
                }}
              />
            </Box>
          ),
        },
      ]
    : []

  const columns = [
    ...staticColumnsBefore,
    ...staticColumnsAfter,
  ]

  const fetchData = async (
    ubicacionId,
    itemId,
    precio,
    soloStockBajo,
    mostrarUltimosCreados,
    mostrarRecetas,
    proveedorId,
    searchText = null,
    soloConPLU = false,
    atributosFilters = {},
    filtroVendedorSi = false,
    filtroVendedorNo = false,
  ) => {
    try {
      // REMOVIDO: await getItemAtributoServicioNoEliminados()
      // Ahora se carga solo una vez al montar el componente
      
      // Normalizar fechas con timezone (patrón de TablaVentas)
      let formattedDateDesde = null
      let formattedDateHasta = null
      
      if (startDate) {
        const formattedStr = startDate.format("YYYY-MM-DD")
        const result = await getFechaHoraActualClient(formattedStr)
        formattedDateDesde = dayjs(result.fechaServidor).startOf("day").toDate()
      }
      
      if (endDate) {
        const formattedStr = endDate.format("YYYY-MM-DD")
        const result = await getFechaHoraActualClient(formattedStr)
        formattedDateHasta = dayjs(result.fechaServidor).endOf("day").toDate()
      }

      const sortField = sortModel?.[0]?.field || null
      const sortOrder = sortModel?.[0]?.sort || null
      
      const data = await getItemAndItemUbicacionServicios(
        page,
        100,
        ubicacionId,
        itemId,
        precio,
        soloStockBajo,
        mostrarUltimosCreados,
        mostrarRecetas,
        proveedorId,
        searchText,
        soloConPLU,
        atributosFilters,
        formattedDateDesde,
        formattedDateHasta,
        sortField,
        sortOrder,
        filtroVendedorSi,
        filtroVendedorNo,
      )
      if (data) {
        const dataWithFechas = (data.data || []).map((row) => {
          const rawFecha = row.fechaListaMontos || row.fecha || null
          const fechaTimestamp = rawFecha ? new Date(rawFecha).getTime() : null
          return {
            ...row,
            fechaListaMontosTimestamp: Number.isFinite(fechaTimestamp) ? fechaTimestamp : null,
            fechaListaMontosDisplay: fechaTimestamp ? formatearFechaHora(fechaTimestamp) : null,
          }
        })
        setItemAndItemUbicacion(dataWithFechas)
        setTotalPages(data.totalPages)
        setTotalCount(data.total)
      }
    } catch (error) {
      console.error("Error fetching servicios inventory data:", error)
    } finally {
      setLoading(false)
    }
  }

  const handleExportVerServiciosPdf = async () => {
    if (isGeneratingPdf) return
    const deliveryContext = { targetWindow: reservePdfTarget() }
    setIsGeneratingPdf(true)
    try {
      const limit = 200
      const sortField = sortModel?.[0]?.field || "fechaListaMontosTimestamp"
      const sortOrder = sortModel?.[0]?.sort || "desc"

      let formattedDateDesde = null
      let formattedDateHasta = null

      if (startDate) {
        const formattedStr = startDate.format("YYYY-MM-DD")
        const result = await getFechaHoraActualClient(formattedStr)
        formattedDateDesde = dayjs(result.fechaServidor).startOf("day").toDate()
      }

      if (endDate) {
        const formattedStr = endDate.format("YYYY-MM-DD")
        const result = await getFechaHoraActualClient(formattedStr)
        formattedDateHasta = dayjs(result.fechaServidor).endOf("day").toDate()
      }

      if (!ubicaciones || ubicaciones.length === 0) {
        await getUbicacion()
      }

      const fetchPageForPdf = async (pageToLoad) => {
        const response = await getItemAndItemUbicacionServicios(
          pageToLoad,
          limit,
          filters.ubicacionId,
          filters.itemId,
          filters.precio,
          filters.soloStockBajo,
          filters.mostrarUltimosCreados,
          filters.mostrarRecetas,
          filters.proveedorId,
          filters.searchText,
          !!filters.soloItemsConPLU,
          filtrosAtributos,
          formattedDateDesde,
          formattedDateHasta,
          sortField,
          sortOrder,
          filtroEsVendedor,
          filtroNoEsVendedor,
        )

        const rows = (response?.data || []).map((row) => {
          const rawFecha = row.fechaListaMontos || row.fecha || null
          const fechaTimestamp = rawFecha ? new Date(rawFecha).getTime() : null
          const fechaDisplay = fechaTimestamp ? formatearFechaHora(fechaTimestamp) : "-"
          return {
            fecha: fechaDisplay || "-",
            destino: row.ubicacion || "",
            servicio: row.codigo || "",
            proveedor: row.proveedor || "",
            costo: Number(row.precioProveedor || 0),
            categoria:
              row.activeAttributes?.itemDatoAtributo6 ||
              row.activeAttributes?.itemDatoAtributo1 ||
              "-",
            vendedor: row.vendedor === true || row.esVendedor === true,
          }
        })

        return {
          rows,
          totalPages: Number(response?.totalPages || 1),
        }
      }

      const firstPage = await fetchPageForPdf(1)
      let allRows = [...firstPage.rows]

      for (let currentPage = 2; currentPage <= firstPage.totalPages; currentPage += 1) {
        const pageData = await fetchPageForPdf(currentPage)
        allRows = allRows.concat(pageData.rows)
      }

      if (!allRows.length) {
        alert("No hay registros para exportar con los filtros actuales.")
        return
      }

      const destinoLabel = filters.ubicacionId
        ? ubicaciones?.find((u) => Number(u.id) === Number(filters.ubicacionId))?.descripcion ||
          `ID ${filters.ubicacionId}`
        : null
      const servicioLabel = filters.itemData?.descripcion || filters.itemData?.codigo || (filters.itemId ? `ID ${filters.itemId}` : null)
      const proveedorLabel = filters.proveedorId ? `ID ${filters.proveedorId}` : null
      const categoriaLabel =
        filtrosAtributos?.itemDatoAtributo6 || filtrosAtributos?.itemDatoAtributo1 || null

      let logoBase64 = null
      try {
        const params = await getParametrosGlobales(["logoNavbarTenant"])
        logoBase64 = params?.logoNavbarTenant || null
      } catch (e) { /* ignorar */ }

      generarPdfVerServicios({
        rows: allRows,
        filtros: {
          fechaDesde: startDate ? startDate.format("DD/MM/YYYY") : null,
          fechaHasta: endDate ? endDate.format("DD/MM/YYYY") : null,
          destino: destinoLabel,
          servicio: servicioLabel,
          proveedor: proveedorLabel,
          categoria: categoriaLabel,
          orden: `${SORT_FIELD_LABELS[sortField] || sortField} (${sortOrder.toUpperCase()})`,
        },
        usuario: user?.usuario || user?.nombre || "Usuario",
        logoBase64,
        deliveryContext,
      })
    } catch (error) {
      console.error("Error exportando PDF de Ver Servicios:", error)
      alert("No se pudo generar el PDF. Intente nuevamente.")
    } finally {
      setIsGeneratingPdf(false)
    }
  }

  useEffect(() => {
    const hasActiveFilters =
      Object.keys(filters).length > 0 &&
      Object.values(filters).some((value) => value !== null && value !== false && value !== "")

    if (hasActiveFilters || startDate || endDate) {
      fetchData(
        filters.ubicacionId,
        filters.itemId,
        filters.precio,
        filters.soloStockBajo,
        filters.mostrarUltimosCreados,
        filters.mostrarRecetas,
        filters.proveedorId,
        filters.searchText,
        !!filters.soloItemsConPLU,
        filtrosAtributos,
        filtroEsVendedor,
        filtroNoEsVendedor,
      )
    } else {
      fetchData(null, null, null, null, null, null, null, null, false, filtrosAtributos, filtroEsVendedor, filtroNoEsVendedor)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, alignment, filters, startDate, endDate, filtrosAtributosKey, sortModel, filtroEsVendedor, filtroNoEsVendedor])

  const handleChange = (_, newAlignment) => {
    if (newAlignment) setAlignment(newAlignment)
  }

  const handleOpenModal = async (transaccionRow) => {
    console.log(transaccionRow)
    setItemEditable(transaccionRow)
    setOpenModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
    fetchData(
      filters.ubicacionId,
      filters.itemId,
      filters.precio,
      filters.soloStockBajo,
      filters.mostrarUltimosCreados,
      filters.mostrarRecetas,
      filters.proveedorId,
      filters.searchText,
      !!filters.soloItemsConPLU,
      filtrosAtributos,
      filtroEsVendedor,
      filtroNoEsVendedor,
    )
  }

  const handleDeleteService = async () => {
    if (!itemToDelete) return
    
    try {
      setLoading(true)
      
      // Eliminar por triple (item + ubicación + proveedor)
      await bulkDeleteItems(
        [itemToDelete.idItem],
        itemToDelete.idUbicacion || ubicacionSeleccionada?.id,
        itemToDelete.idEntidad
      )
      
      // Recargar datos
      await fetchData(
        filters.ubicacionId,
        filters.itemId,
        filters.precio,
        filters.soloStockBajo,
        filters.mostrarUltimosCreados,
        filters.mostrarRecetas,
        filters.proveedorId,
        filters.searchText,
        !!filters.soloItemsConPLU,
        filtrosAtributos,
        filtroEsVendedor,
        filtroNoEsVendedor,
      )
      
      setOpenDeleteConfirmModal(false)
      setItemToDelete(null)
    } catch (error) {
      console.error("Error al eliminar servicio:", error)
      alert("Error al eliminar el servicio")
    } finally {
      setLoading(false)
    }
  }

  const handleFilterSearch = (newFilters) => {
    const proveedorIdSeleccionado = selectedProveedorFiltro ? selectedProveedorFiltro.id : null
    setFilters((prev) => ({
      ...prev,
      ...newFilters,
      proveedorId:
        proveedorIdSeleccionado !== null
          ? proveedorIdSeleccionado
          : typeof newFilters.proveedorId === "number"
            ? newFilters.proveedorId
            : null,
      soloItemsConPLU:
        typeof newFilters.soloItemsConPLU === "boolean" ? newFilters.soloItemsConPLU : prev.soloItemsConPLU,
    }))
    setPage(1)
    setSelectedItems([])
    setSelectAll(false)
    setUbicacionSeleccionada(newFilters.ubicacionId || null)
    if (typeof newFilters.soloItemsConPLU === "boolean") {
      setSoloItemsConPLU(newFilters.soloItemsConPLU)
    }
    setItemsSeleccionadosParaEliminar([])
    setModoEliminacion(false)
  }

  const handleAlignmentChange = (_, newAlignment) => {
    if (newAlignment) setAlignment(newAlignment)
  }

  const handleRefresh = () => {
    setFilters({})
    setPage(1)
    setSelectedItems([])
    setSelectAll(false)
    setFiltrosAtributos({})
    setFiltroEsVendedor(false)
    setFiltroNoEsVendedor(false)
    setFiltroUltimosCreados(false)
    setSoloItemsConPLU(false)
    setModoEliminacion(false)
    setItemsSeleccionadosParaEliminar([])
    setUbicacionSeleccionada(null)
    setSelectedProveedorFiltro(null)
    setSearchTextProveedorFiltro("")
    setStartDate(null)
    setEndDate(null)
    fetchData(null, null, null, null, null, null, null, null, false, {}, false, false)
  }

  const handleSelectItem = (itemId, isSelected) => {
    if (isSelected) {
      setSelectedItems((prev) => [...prev, itemId])
      if (selectedItems.length + 1 === itemAndItemUbicacion.length) {
        setSelectAll(true)
      }
    } else {
      setSelectedItems((prev) => prev.filter((id) => id !== itemId))
      setSelectAll(false)
    }
  }

  const handleSelectAll = (isSelected) => {
    if (isSelected) {
      const allItemIds = itemAndItemUbicacion.map((item) => item.id)
      setSelectedItems(allItemIds)
      setSelectAll(true)
    } else {
      setSelectedItems([])
      setSelectAll(false)
    }
  }

  const handleGenerateCompra = () => {
    const selectedItemsData = itemAndItemUbicacion.filter((item) => selectedItems.includes(item.id))

    const dataForCompra = {
      selectedItems: selectedItemsData,
      proveedor: filters.proveedorId
        ? {
            id: filters.proveedorId,
          }
        : null,
      ubicacion: filters.ubicacionId
        ? {
            id: filters.ubicacionId,
          }
        : null,
    }

    console.log("Abriendo modal de compra con datos:", dataForCompra)

    setCompraData(dataForCompra)
    setOpenCompraModal(true)
  }

  const handleCloseCompraModal = () => {
    setOpenCompraModal(false)
    setCompraData(null)
    setSelectedItems([])
    setSelectAll(false)
  }

  const handleCloseCrearServicioModal = () => {
    setOpenCrearServicioModal(false)
  }

  const handleServicioCreado = () => {
    // Cerrar el modal
    setOpenCrearServicioModal(false)
    // Refrescar la tabla después de crear el servicio
    fetchData(
      filters.ubicacionId,
      filters.itemId,
      filters.precio,
      filters.soloStockBajo,
      filters.mostrarUltimosCreados,
      filters.mostrarRecetas,
      filters.proveedorId,
      filters.searchText,
      !!filters.soloItemsConPLU,
      filtrosAtributos,
      filtroEsVendedor,
      filtroNoEsVendedor,
    )
  }

  const handleSelectItemForDelete = (itemId, isSelected) => {
    if (isSelected) {
      setItemsSeleccionadosParaEliminar((prev) => [...prev, itemId])
    } else {
      setItemsSeleccionadosParaEliminar((prev) => prev.filter((id) => id !== itemId))
    }
  }

  const handleSelectAllForDelete = (isSelected) => {
    if (isSelected) {
      const allItemIds = itemAndItemUbicacion.map((item) => item.idItem) // Usar idItem para la selección masiva
      setItemsSeleccionadosParaEliminar(allItemIds)
    } else {
      setItemsSeleccionadosParaEliminar([])
    }
  }

  const handleOpenDeleteModal = () => {
    if (itemsSeleccionadosParaEliminar.length === 0) {
      alert("Debe seleccionar al menos un item para eliminar")
      return
    }
    setOpenConfirmDeleteModal(true)
  }

  const handleConfirmDelete = async () => {
    try {
      setLoading(true)

      const result = await bulkDeleteItems(
        itemsSeleccionadosParaEliminar,
        filters.ubicacionId || null, // Pasar ubicacionId para eliminación específica
      )

      console.log("Eliminación exitosa:", result)

      setOpenConfirmDeleteModal(false)
      setItemsSeleccionadosParaEliminar([])
      setModoEliminacion(false)

      await fetchData(
        filters.ubicacionId,
        filters.itemId,
        filters.precio,
        filters.soloStockBajo,
        filters.mostrarUltimosCreados,
        filters.mostrarRecetas,
        filters.proveedorId,
        filters.searchText,
        !!filters.soloItemsConPLU,
        filtrosAtributos,
        filtroEsVendedor,
        filtroNoEsVendedor,
      )

      alert(`Se eliminaron ${result.eliminados || itemsSeleccionadosParaEliminar.length} item(s) exitosamente`)
    } catch (error) {
      console.error("Error al eliminar items:", error)
      alert("Error al eliminar items: " + (error.response?.data?.message || error.message))
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return <SpinnerLading />
  }

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          width: "100%",
          maxWidth: "100%",
          overflow: "hidden",
          position: "relative",
          padding: "2px 20px 5px 25px",
          paddingRight: 10,
          minWidth: 0,
          "&::-webkit-scrollbar": {
            display: "none",
          },
          scrollbarWidth: "none", // Firefox
          msOverflowStyle: "none", // IE and Edge
        }}
      >
        <Box
          sx={{
            flexShrink: 0,
            backgroundColor: "#f5f5f5",
            boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
            borderRadius: "8px 8px 0 0",
          }}
        >
          {/* Filtros básicos */}
          <Box sx={{ p: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  alignItems: { xs: "stretch", md: "center" },
                  flexWrap: "wrap",
                  gap: 2,
                }}
              >
              {/* Filtros de Fecha - A la izquierda */}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Fecha Desde"
                  value={startDate}
                  onChange={(newValue) => setStartDate(newValue)}
                  format="DD/MM/YYYY"
                  slotProps={{
                    textField: {
                      size: "small",
                      sx: {
                        width: 170,
                        minWidth: 170,
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: startDate ? alpha(theme.palette.primary.main, 0.05) : "white",
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Fecha Hasta"
                  value={endDate}
                  onChange={(newValue) => setEndDate(newValue)}
                  format="DD/MM/YYYY"
                  slotProps={{
                    textField: {
                      size: "small",
                      sx: {
                        width: 170,
                        minWidth: 170,
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: endDate ? alpha(theme.palette.primary.main, 0.05) : "white",
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
              {(startDate || endDate) && (
                <Tooltip title="Limpiar fechas">
                  <IconButton
                    size="small"
                    onClick={() => {
                      setStartDate(null)
                      setEndDate(null)
                    }}
                    sx={{
                      color: theme.palette.error.main,
                      backgroundColor: alpha(theme.palette.error.main, 0.08),
                      "&:hover": {
                        backgroundColor: alpha(theme.palette.error.main, 0.15),
                      },
                    }}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}

              {/* Buscador - A la derecha */}
              <BuscadorItemsUbicaciones
                  onSearch={handleFilterSearch}
                  vieneDe="inventario"
                  dropdownEsServicio={true}
                  sinPaper
                  unaLinea
                  sinContenedorInterno
                  containerSx={{ flex: 1, minWidth: 0 }}
                  onReset={() => {
                    handleRefresh()
                  }}
                  extraAfterUbicacion={
                    <Box
                      sx={{
                        flex: { xs: "1 1 100%", sm: "0 1 220px" },
                        minWidth: { xs: "100%", sm: 220 },
                        position: "relative",
                        zIndex: 997,
                      }}
                    >
                      <Autocomplete
                        size="small"
                        disablePortal={false}
                        forcePopupIcon={false}
                        clearIcon={<ClearIcon sx={{ fontSize: 16 }} />}
                        options={entidadesClientesTresLetras || []}
                        getOptionLabel={(opt) => {
                          if (!opt) return ""
                          const partes = []
                          if (opt.razonSocial) partes.push(opt.razonSocial)
                          if (opt.nombre) partes.push(opt.nombre)
                          if (opt.descripcion) partes.push(opt.descripcion)
                          if (opt.apellido) partes.push(opt.apellido)
                          return partes.join(" - ") || "Sin nombre"
                        }}
                        value={selectedProveedorFiltro}
                        onChange={(e, newValue) => {
                          setSelectedProveedorFiltro(newValue)
                        }}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason === "input" || reason === "clear") {
                            setSearchTextProveedorFiltro(newInputValue || "")
                          }
                        }}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        componentsProps={{
                          popper: {
                            sx: { zIndex: 10000 },
                            placement: "bottom-start",
                            disablePortal: false,
                          },
                          paper: {
                            sx: { maxHeight: 300 },
                          },
                        }}
                        filterOptions={(options, state) => {
                          const input = state.inputValue || ""
                          // Mantener política de 3 caracteres (contando espacios)
                          if (input.length < 3) return []
                          // No refiltrar en MUI, usar lo que vino del server
                          return options
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Proveedor"
                            variant="outlined"
                            placeholder="Buscar proveedor"
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <>
                                  <InputAdornment position="start">
                                    <BusinessIcon sx={{ fontSize: 18 }} color="action" />
                                  </InputAdornment>
                                  {params.InputProps.startAdornment}
                                </>
                              ),
                              endAdornment: params.InputProps.endAdornment,
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                borderRadius: 1,
                                fontSize: "0.875rem",
                                minHeight: 40,
                                height: 40,
                                alignItems: "center",
                                backgroundColor: alpha(theme.palette.background.paper, 0.5),
                              },
                              "& .MuiInputLabel-root": {
                                fontSize: "0.875rem",
                              },
                              "& .MuiAutocomplete-endAdornment": {
                                right: 8,
                              },
                            }}
                          />
                        )}
                      />
                    </Box>
                  }
                  extraActionButtons={
                    <>
                      <Tooltip title={isGeneratingPdf ? "Generando PDF..." : "PDF"}>
                        <span>
                          <IconButton
                            onClick={handleExportVerServiciosPdf}
                            disabled={loading || isGeneratingPdf}
                            size="small"
                            sx={{
                              color: alpha("#5b5b5f", 0.9),
                              "&:hover": { backgroundColor: alpha("#5b5b5f", 0.1) },
                            }}
                          >
                            {isGeneratingPdf ? (
                              <CircularProgress size={16} />
                            ) : (
                              <PictureAsPdfIcon fontSize="small" />
                            )}
                          </IconButton>
                        </span>
                      </Tooltip>
                      <Tooltip title="Crear nuevo servicio">
                        <Button
                          variant="contained"
                          startIcon={<AddIcon />}
                          onClick={() => setOpenCrearServicioModal(true)}
                          sx={{
                            textTransform: "none",
                            borderRadius: 2,
                            boxShadow: 2,
                            backgroundColor: "#5b5b5f",
                            "&:hover": {
                              backgroundColor: alpha("#5b5b5f", 0.8),
                            },
                          }}
                        >
                          Crear
                        </Button>
                      </Tooltip>
                    </>
                  }
                />

            </Box>
          </Box>

          {(mostrarFiltroAtributos || mostrarFiltroPLU) && (
            <Box
              sx={{
                p: 2,
                pt: 0,
                display: "flex",
                flexDirection: "column",
                gap: 2,
                borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              }}
            >
              {mostrarFiltroAtributos && itemAtributoServicioNoEliminados && itemAtributoServicioNoEliminados.length > 0 && (
                <Paper
                  elevation={2}
                  sx={{
                    p: 2,
                    backgroundColor: alpha(theme.palette.primary.main, 0.02),
                    border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: theme.palette.primary.main }}>
                      Filtros por Atributos
                    </Typography>
                    <IconButton size="small" onClick={() => setMostrarFiltroAtributos(false)}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>

                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: { xs: "1fr", md: "minmax(240px, 1fr) auto" },
                      gap: 2,
                      alignItems: "center",
                    }}
                  >
                    {mapearAtributosACampos().map((atributo) => (
                      <TextField
                        key={atributo.campo}
                        label={atributo.descripcion}
                        size="small"
                        value={filtrosAtributos[atributo.campo] || ""}
                        onChange={(e) => handleAtributoFilterChange(atributo.campo, e.target.value)}
                        onKeyDown={handleAtributoKeyDown}
                        placeholder={`Buscar...`}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon fontSize="small" color="action" />
                            </InputAdornment>
                          ),
                          endAdornment: filtrosAtributos[atributo.campo] && (
                            <InputAdornment position="end">
                              <IconButton
                                size="small"
                                onClick={() => handleAtributoFilterChange(atributo.campo, "")}
                                edge="end"
                              >
                                <ClearIcon fontSize="small" />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          width: 320,
                          minWidth: 320,
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: filtrosAtributos[atributo.campo]
                              ? alpha(theme.palette.primary.main, 0.05)
                              : "white",
                          },
                        }}
                      />
                    ))}
                    <Box
                      sx={{
                        display: "flex",
                        gap: "20px",
                        alignItems: "center",
                        justifyContent: { xs: "flex-start", md: "flex-start" },
                        flexWrap: "wrap",
                        ml: "20px",
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="small"
                            checked={filtroEsVendedor}
                            onChange={(e) => setFiltroEsVendedor(e.target.checked)}
                          />
                        }
                        label="Es Vendedor"
                        sx={{ ".MuiFormControlLabel-label": { fontSize: "0.875rem" } }}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="small"
                            checked={filtroNoEsVendedor}
                            onChange={(e) => setFiltroNoEsVendedor(e.target.checked)}
                          />
                        }
                        label="No es Vendedor"
                        sx={{ ".MuiFormControlLabel-label": { fontSize: "0.875rem" } }}
                      />
                    </Box>
                  </Box>

                </Paper>
              )}

              {mostrarFiltroPLU && showPluExport && (
                <Paper
                  elevation={2}
                  sx={{
                    p: 2,
                    backgroundColor: alpha(theme.palette.success.main, 0.02),
                    border: `1px solid ${alpha(theme.palette.success.main, 0.2)}`,
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: theme.palette.success.main }}>
                      Exportar PLUs de Balanza
                    </Typography>
                    <IconButton size="small" onClick={() => setMostrarFiltroPLU(false)}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>

                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1, maxWidth: 400 }}>
                    <Button
                      onClick={handleExportarPLUsBalanza}
                      variant="contained"
                      size="medium"
                      startIcon={<FileDownloadIcon />}
                      disabled={!isExportButtonEnabled()}
                      sx={{
                        backgroundColor: isExportButtonEnabled() ? "success.main" : "grey.400",
                        color: "white",
                        textTransform: "none",
                        "&:hover": {
                          backgroundColor: isExportButtonEnabled() ? "success.dark" : "grey.400",
                        },
                      }}
                    >
                      Exportar PLUs
                    </Button>

                    {!isExportButtonEnabled() && (
                      <Typography variant="caption" color="text.secondary">
                        {!ubicacionSeleccionada
                          ? " Seleccione una ubicación antes de exportar"
                          : !parametrosGlobales.fabricanteBalanza
                            ? " Fabricante de balanza no configurado"
                            : "Listo para exportar"}
                      </Typography>
                    )}
                  </Box>
                </Paper>
              )}
            </Box>
          )}
        </Box>

        <Drawer
          anchor="right"
          open
          hideBackdrop
          variant="persistent"
          ModalProps={{ keepMounted: true }}
          sx={{
            "& .MuiDrawer-paper": {
              width: FILTER_PANEL_WIDTH,
              top: 0,
              height: "100vh",
              backgroundColor: alpha(theme.palette.background.paper, 0.98),
              borderLeft: `2px solid ${alpha(theme.palette.primary.main, 0.2)}`,
              boxShadow: "-4px 0 20px rgba(0,0,0,0.1)",
              zIndex: 1000,
              overflowX: "hidden",
            },
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", height: "100%", p: 1 }}>
            {/* <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: 2,
                pb: 1,
                borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              }}
            >
              <Typography variant="caption" sx={{ fontWeight: 700, letterSpacing: 0.5, color: "text.secondary" }}>
                Filtros
              </Typography>
            </Box> */}

            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 2 }}>
              {/* Filtrar por atributos - PRIMERO */}
              <Tooltip title="Filtrar por atributos" placement="left">
                <IconButton
                  onClick={() => setMostrarFiltroAtributos(!mostrarFiltroAtributos)}
                  sx={{
                    color: mostrarFiltroAtributos ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    "& svg": {
                      color: mostrarFiltroAtributos ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    },
                  }}
                >
                  <Badge badgeContent={badgeFiltrosAtributos} color="primary">
                    <FilterAltIcon />
                  </Badge>
                </IconButton>
              </Tooltip>

              {/* OCULTO: Últimos creados */}

              {/* OCULTO: Solo items con PLU */}
              {/* {showPluExport && (
                <Tooltip title="Solo items con PLU" placement="left">
                  <IconButton
                    onClick={handleToggleFiltroPLU}
                    sx={{
                      color: soloItemsConPLU ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                      "& svg": {
                        color: soloItemsConPLU ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                      },
                    }}
                  >
                    <FormatListNumberedIcon />
                  </IconButton>
                </Tooltip>
              )} */}

              {/* OCULTO: Divider de acciones deshabilitadas */}

              {/* OCULTO: Modo eliminación */}

              {/* OCULTO: Exportar PLUs balanza */}
              {/* {showPluExport && (
                <Tooltip title="Exportar PLUs balanza" placement="left">
                  <IconButton
                    onClick={() => setMostrarFiltroPLU(!mostrarFiltroPLU)}
                    sx={{
                      color: mostrarFiltroPLU ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                      "& svg": {
                        color: mostrarFiltroPLU ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                      },
                    }}
                  >
                    <FileDownloadIcon />
                  </IconButton>
                </Tooltip>
              )} */}
            </Box>
          </Box>
        </Drawer>

        <Box 
          sx={{ 
            flex: 1, 
            overflow: "hidden",
            position: "relative",
            minWidth: 0,
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none", // Firefox
            msOverflowStyle: "none", // IE and Edge
          }}
        >
          <Paper
            sx={{
              height: "100%",
              width: "100%",
              boxShadow: "none",
              border: "1px solid rgba(0,0,0,0.08)",
              borderTop: "none",
              overflow: "hidden",
              overflowX: "auto",
              scrollbarWidth: "thin", // Firefox
              "&::-webkit-scrollbar": {
                height: "8px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#888",
                borderRadius: "10px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#f1f1f1",
                borderRadius: "10px",
              },
            }}
          >
            <Box sx={{ width: "100%", height: "100%", minWidth: DATA_GRID_MIN_WIDTH }}>
              <DataGrid
                className="tablaVentasDataGrid"
                rows={itemAndItemUbicacion}
                columns={columns}
                getRowId={(row) => row.id}
                pageSizeOptions={[5, 10]}
                pagination
                getRowHeight={() => 35}
                headerHeight={35}
                paginationMode="server"
                pageSize={100}
                sortModel={sortModel}
                onSortModelChange={handleSortModelChange}
                sortingOrder={["desc", "asc"]}
                sortingMode="server"
                sx={{
                  minWidth: DATA_GRID_MIN_WIDTH,
                  width: "100%",
                  height: "100%",
                  border: 0,
                  overflow: "auto",
                  "&::-webkit-scrollbar": {
                    display: "none",
                  },
                  scrollbarWidth: "none", // Firefox
                  msOverflowStyle: "none", // IE and Edge
                  "& .MuiDataGrid-footerContainer": {
                    display: "none !important",
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "#5b5b5f",
                    color: "white",
                    borderBottom: "2px solid #333",
                    height: "45px !important",
                    minHeight: "45px !important",
                    maxHeight: "45px !important",
                  },
                  "& .MuiDataGrid-columnHeader": {
                    height: "45px !important",
                    minHeight: "45px !important",
                    maxHeight: "45px !important",
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    color: "white !important",
                    lineHeight: "45px !important",
                  },
                  "& .MuiDataGrid-columnHeaderTitle .MuiDataGrid-menuIconButton": {
                    color: "white !important",
                  },
                  "& .MuiDataGrid-menuIconButton": {
                    color: "rgb(244, 177, 14) !important",
                  },
                  "& .MuiDataGrid-columnHeader[data-field='action'] .MuiDataGrid-iconButtonContainer": {
                    display: "none !important",
                  },
                  "& .MuiDataGrid-columnHeader[data-field='action'] .MuiDataGrid-menuIcon": {
                    display: "none !important",
                  },
                  "& .MuiDataGrid-columnHeader[data-field='action'] .MuiDataGrid-sortIcon": {
                    display: "none !important",
                  },
                  "& .MuiInputBase-root": {
                    color: "rgb(244, 177, 14) !important",
                  },
                  "& .MuiTablePagination-root": {
                    color: "black !important",
                  },
                  "& .MuiSelect-icon": {
                    color: "rgb(244, 177, 14) !important",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "1px solid #ccc",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  },
                  "& .MuiDataGrid-row": {
                    "&:nth-of-type(even)": {
                      backgroundColor: "#F7F7F7",
                    },
                    "&:hover": {
                      backgroundColor: "#E3EAFD",
                      transition: "background 0.3s ease",
                    },
                  },
                  "& .row-devolucion": {
                    backgroundColor: alpha("#9e9e9e !important", 0.05),
                    "&:hover": {
                      backgroundColor: alpha("#9e9e9e !important", 0.1),
                    },
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    lineHeight: "none !important",
                    height: "100% !important",
                    maxHeight: "100% !important",
                    overflow: "auto !important",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                      height: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#888",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "#f1f1f1",
                      borderRadius: "10px",
                    },
                  },
                  "& .MuiDataGrid-footerContainer": {
                    position: "sticky",
                    bottom: 0,
                    backgroundColor: "#ffffff",
                    borderTop: "1px solid #ddd",
                    zIndex: 10,
                  },
                }}
                components={{
                  Pagination: () => null,
                }}
              />
            </Box>
          </Paper>
        </Box>

        <Box
          sx={{
            flexShrink: 0,
            backgroundColor: "#f5f5f5",
            borderRadius: "0 0 8px 8px",
            borderTop: "1px solid rgba(0,0,0,0.08)",
            padding: "0px",
            paddingBottom: "10px",
            zIndex: 1,
          }}
        >
          <CustomPagination
            currentPage={page}
            totalPages={totalPages}
            totalCount={totalCount}
            vieneDe={"inventaryComponent"}
            onPageChange={(newPage) => setPage(newPage)}
          />
        </Box>

        {modoEliminacion && itemsSeleccionadosParaEliminar.length > 0 && (
          <Box
            sx={{
              mt: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 2,
              backgroundColor: alpha(theme.palette.error.main, 0.08),
              borderRadius: 2,
              border: `2px solid ${theme.palette.error.main}`,
              animation: "pulse 2s ease-in-out infinite",
              "@keyframes pulse": {
                "0%, 100%": { borderColor: theme.palette.error.main },
                "50%": { borderColor: alpha(theme.palette.error.main, 0.5) },
              },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <DeleteIcon color="error" />
              <Box>
                <Typography variant="body1" sx={{ fontWeight: 700, color: "error.main" }}>
                  {itemsSeleccionadosParaEliminar.length} item(s) seleccionado(s) para eliminar
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {hayFiltroUbicacion
                    ? `Se eliminará solo de la ubicación filtrada`
                    : "Se eliminarán los items completos y todas sus ubicaciones"}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                variant="outlined"
                size="small"
                color="inherit"
                onClick={() => {
                  setItemsSeleccionadosParaEliminar([])
                }}
                sx={{ textTransform: "none" }}
              >
                Cancelar
              </Button>

              <Button
                variant="contained"
                size="small"
                color="error"
                startIcon={<DeleteIcon />}
                onClick={handleOpenDeleteModal}
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  "&:hover": {
                    backgroundColor: theme.palette.error.dark,
                  },
                }}
              >
                Eliminar ({itemsSeleccionadosParaEliminar.length})
              </Button>
            </Box>
          </Box>
        )}

        {/* Modal de edición de servicios - Ahora usa CreateServicioComponent unificado */}
        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
          closeAfterTransition
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: { xs: "95%", sm: "90%", md: "85%", lg: "80%" },
              maxWidth: "1200px",
              height: "90vh",
              bgcolor: "background.paper",
              boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
              borderRadius: "12px",
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
              position: "relative",
              animation: "fadeIn 0.3s ease-out",
              "@keyframes fadeIn": {
                from: { opacity: 0, transform: "translateY(-20px)" },
                to: { opacity: 1, transform: "translateY(0)" },
              },
            }}
          >
            {openModal && (
              <CreateServicioComponent onClose={handleCloseModal} selectedItem={itemEditable} />
            )}
          </Box>
        </Modal>

        <Modal
          open={openCompraModal}
          onClose={handleCloseCompraModal}
          aria-labelledby="compra-modal-title"
          aria-describedby="compra-modal-description"
          closeAfterTransition
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 1,
          }}
        >
          <Box
            sx={{
              width: "95vw",
              height: "90vh",
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                p: 2,
                borderBottom: "1px solid rgba(0,0,0,0.12)",
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
              }}
            >
              <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>
                Generar Compra - {selectedItems.length} items seleccionados
              </Typography>
              <IconButton onClick={handleCloseCompraModal} size="small">
                <CloseIcon />
              </IconButton>
            </Box>

            <Box sx={{ flex: 1, overflow: "auto", p: 2 }}>
              {compraData && (
                <GestionGenerarCompraComponent
                  preloadedData={compraData}
                  onClose={handleCloseCompraModal}
                  isModal={true}
                />
              )}
            </Box>
          </Box>
        </Modal>
        {/* START UPDATE */}
        <Modal
          open={openConfirmDeleteModal}
          onClose={() => setOpenConfirmDeleteModal(false)}
          aria-labelledby="confirm-delete-modal-title"
          aria-describedby="confirm-delete-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              minWidth: { xs: "90%", sm: 500 },
              maxWidth: 600,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <WarningIcon color="error" sx={{ fontSize: 48 }} />
              <Typography id="confirm-delete-modal-title" variant="h6" component="h2" sx={{ fontWeight: 700 }}>
                 Confirmar Eliminación
              </Typography>
            </Box>

            <Divider sx={{ mb: 2 }} />

            <Typography id="confirm-delete-modal-description" variant="body1" sx={{ mb: 2 }}>
              Está a punto de eliminar{" "}
              <strong style={{ color: theme.palette.error.main }}>{itemsSeleccionadosParaEliminar.length}</strong>{" "}
              item(s).
            </Typography>

            <Box
              sx={{
                p: 2,
                mb: 3,
                backgroundColor: alpha(theme.palette.error.main, 0.05),
                borderRadius: 1,
                border: `1px solid ${alpha(theme.palette.error.main, 0.2)}`,
              }}
            >
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
                {hayFiltroUbicacion
                  ? `Se eliminará la ubicación de estos items, no el item completo.`
                  : "Se eliminarán estos items y TODAS sus ubicaciones de forma permanente (soft delete)."}
              </Typography>
            </Box>

            <Typography variant="body2" color="error" sx={{ mb: 3, fontStyle: "italic" }}>
              Esta acción no se puede deshacer fácilmente.
            </Typography>

            <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
              <Button
                variant="outlined"
                onClick={() => setOpenConfirmDeleteModal(false)}
                sx={{ textTransform: "none" }}
              >
                Cancelar
              </Button>

              <Button
                variant="contained"
                color="error"
                onClick={handleConfirmDelete}
                startIcon={<DeleteIcon />}
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                Confirmar Eliminación
              </Button>
            </Box>
          </Box>
        </Modal>
        {/* END UPDATE */}

        {/* Modal de Crear Servicio */}
        <Modal
          open={openCrearServicioModal}
          onClose={handleCloseCrearServicioModal}
          aria-labelledby="crear-servicio-modal-title"
          aria-describedby="crear-servicio-modal-description"
          closeAfterTransition
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: "90%",
              maxWidth: "1600px",
              height: "90vh",
              bgcolor: "background.paper",
              boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
              borderRadius: "12px",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              position: "relative",
              animation: "fadeIn 0.3s ease-out",
              "@keyframes fadeIn": {
                from: { opacity: 0, transform: "translateY(-20px)" },
                to: { opacity: 1, transform: "translateY(0)" },
              },
            }}
          >
            <IconButton
              onClick={handleCloseCrearServicioModal}
              sx={{
                position: "absolute",
                top: 12,
                right: 12,
                zIndex: 10,
                color: "grey.500",
                backgroundColor: "rgba(0,0,0,0.05)",
                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.1)",
                },
                transition: "background-color 0.2s",
              }}
            >
              <CloseIcon />
            </IconButton>

            {openCrearServicioModal && (
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  overflow: "auto",
                }}
              >
                <CreateServicioComponent onSuccess={handleServicioCreado} />
              </Box>
            )}
          </Box>
        </Modal>

        {/* Modal de confirmación de eliminación */}
        <Modal
          open={openDeleteConfirmModal}
          onClose={() => {
            setOpenDeleteConfirmModal(false)
            setItemToDelete(null)
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              minWidth: 400,
            }}
          >
            <Typography variant="h6" sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1 }}>
              <DeleteIcon color="error" />
              Confirmar Eliminación
            </Typography>
            
            <Typography variant="body1" sx={{ mb: 3 }}>
              ¿Está seguro de eliminar el servicio <strong>{itemToDelete?.codigo}</strong>?
            </Typography>
            
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Esta acción eliminará el servicio de esta ubicación. Los registros en paquetes existentes se mantendrán para auditoría.
            </Typography>
            
            <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
              <Button
                variant="outlined"
                onClick={() => {
                  setOpenDeleteConfirmModal(false)
                  setItemToDelete(null)
                }}
              >
                Cancelar
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={handleDeleteService}
                startIcon={<DeleteIcon />}
              >
                Eliminar
              </Button>
            </Box>
          </Box>
        </Modal>

        {/* Modal de carga al verificar paquetes asociados */}
        <Modal open={loadingPaquetesAsociados} disableEscapeKeyDown>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              p: 3,
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
            }}
          >
            <CircularProgress size={48} />
            <Typography variant="body2" color="text.secondary">
              Verificando grupos asociados...
            </Typography>
          </Box>
        </Modal>

        {/* Modal de bloqueo: servicio con grupos asociados */}
        <Modal
          open={openBlockedDeleteModal}
          onClose={() => {
            setOpenBlockedDeleteModal(false)
            setItemToDelete(null)
            setPaquetesAsociados([])
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              borderRadius: 2,
              minWidth: 480,
              maxWidth: 560,
              maxHeight: "85vh",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Header con advertencia */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                px: 3,
                py: 2,
                bgcolor: alpha(theme.palette.warning.main, 0.12),
                borderBottom: `2px solid ${theme.palette.warning.main}`,
              }}
            >
              <WarningIcon sx={{ fontSize: 28, color: theme.palette.warning.main }} />
              <Typography variant="h6" sx={{ fontWeight: 700, color: theme.palette.warning.dark }}>
                No se puede eliminar el servicio
              </Typography>
            </Box>

            <Box sx={{ p: 3, overflow: "auto", flex: 1 }}>
              {/* Servicio bloqueado */}
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  mb: 2,
                  bgcolor: alpha(theme.palette.error.main, 0.04),
                  borderColor: alpha(theme.palette.error.main, 0.3),
                }}
              >
                <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 0.5 }}>
                  Servicio que intenta eliminar
                </Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, alignItems: "baseline" }}>
                  <Box>
                    <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
                      Servicio
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      {itemToDelete?.codigo}
                      {itemToDelete?.descripcion ? ` — ${itemToDelete.descripcion}` : ""}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
                      Proveedor asociado
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      {itemToDelete?.proveedor ||
                        (paquetesAsociados?.length > 0
                          ? [...new Set(paquetesAsociados.map((p) => p.proveedor).filter(Boolean))].join(", ")
                          : null) ||
                        "N/A"}
                    </Typography>
                  </Box>
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
                  Está asociado a uno o más grupos. Debe retirarlo del grupo o eliminar el grupo primero.
                </Typography>
              </Paper>

              {/* Lista de grupos */}
              <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 700, color: "text.primary" }}>
                Grupos asociados ({paquetesAsociados.length})
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, mb: 2 }}>
                {paquetesAsociados.map((p, idx) => {
                  const recetaSelected = {
                    id: p.idProductoTerminado ?? p.grupo?.id,
                    codigo: p.grupo?.codigo,
                    descripcion: p.grupo?.descripcion,
                    label: p.grupo?.descripcion || p.grupo?.codigo || "N/A",
                  }
                  const destinoSelected = {
                    id: p.idDestino,
                    descripcion: p.destino,
                    label: p.destino,
                  }
                  const fechaInicioSelected = p.fechaInicio ? dayjs(p.fechaInicio) : null
                  return (
                    <Paper
                      key={idx}
                      variant="outlined"
                      sx={{
                        p: 2,
                        bgcolor: alpha(theme.palette.primary.main, 0.03),
                        borderColor: alpha(theme.palette.primary.main, 0.2),
                        borderLeft: `4px solid ${theme.palette.primary.main}`,
                      }}
                    >
                      <Box sx={{ display: "grid", gap: 0.75 }}>
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
                          <Box>
                            <Typography variant="caption" color="text.secondary">Grupo</Typography>
                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                              {p.grupo?.descripcion || p.grupo?.codigo || "N/A"}
                            </Typography>
                          </Box>
                          <Box>
                            <Typography variant="caption" color="text.secondary">Destino</Typography>
                            <Typography variant="body2">{p.destino}</Typography>
                          </Box>
                          <Box>
                            <Typography variant="caption" color="text.secondary">Fechas</Typography>
                            <Typography variant="body2">
                              {p.fechaInicio ? dayjs(p.fechaInicio).format("DD/MM/YYYY") : "N/A"}
                              {p.fechaFin ? ` — ${dayjs(p.fechaFin).format("DD/MM/YYYY")}` : ""}
                            </Typography>
                          </Box>
                          <Box>
                            <Typography variant="caption" color="text.secondary">Proveedor</Typography>
                            <Typography variant="body2">{p.proveedor}</Typography>
                          </Box>
                        </Box>
                        {/* <Button
                          size="small"
                          variant="outlined"
                          color="primary"
                          startIcon={<ArrowForwardIcon fontSize="small" />}
                          onClick={() => {
                            setOpenBlockedDeleteModal(false)
                            setItemToDelete(null)
                            setPaquetesAsociados([])
                            navigate(`/${tenantPath}/tablaReceta`, {
                              state: {
                                filtrosPaquete: {
                                  recetaSelected,
                                  destinoSelected,
                                  fechaInicioSelected: fechaInicioSelected ? fechaInicioSelected.toISOString() : null,
                                },
                              },
                            })
                          }}
                          sx={{ mt: 1.5, alignSelf: "flex-start", textTransform: "none" }}
                        >
                          Ir a Grupos de viaje
                        </Button> */}
                      </Box>
                    </Paper>
                  )
                })}
              </Box>

              {/* Instrucción */}
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  bgcolor: alpha(theme.palette.info.main, 0.06),
                  borderColor: alpha(theme.palette.info.main, 0.25),
                }}
              >
                <Typography variant="body2" color="text.secondary">
                  Para eliminar este servicio, vaya a <strong>Grupos de viaje</strong> y retire el servicio del grupo correspondiente, o elimine el grupo.
                </Typography>
              </Paper>
            </Box>

            {/* Footer con botón */}
            <Box
              sx={{
                px: 3,
                py: 2,
                borderTop: `1px solid ${theme.palette.divider}`,
                bgcolor: alpha(theme.palette.background.paper, 0.5),
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setOpenBlockedDeleteModal(false)
                  setItemToDelete(null)
                  setPaquetesAsociados([])
                }}
                sx={{ minWidth: 120 }}
              >
                Entendido
              </Button>
            </Box>
          </Box>
        </Modal>
      </Box>
    </>
  )
}


